import Cookies from 'js-cookie';
import {webSocketLogin} from "@/utils/websocket/websocket_core.js";
import _ from "lodash";

export const state = () => ({
	head: {},
	navs: [
		{
			"id":"1280710466467188738",
			"addTime":"2021-07-08 11:49:04",
			"updateTime":"2021-11-09 14:14:57",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"/",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"首页",
			"value":"Home",
			"sort":1,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"keywords":"律回网，律师，法律，法律论坛",
				"description":"由中国国际贸易促进委员会主办，中国国际贸易促进委员会商事法律服务中心、长沙市人民政府承办的“第五届国际商事法律合作论坛”，将由律回网在2023年3月23日线上承办",
				"title":{
					"zh":"第五届国际商事法律合作论坛",
					"en":"The Fifth International Commercial Legal Cooperation Forum"
				},
			},
			"remark":"/",
			"children":[

			]
		},
		{
			"id":"1280765464718790657",
			"addTime":"2021-07-08 15:27:37",
			"updateTime":"2021-11-09 14:15:13",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"/live",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"大会直播",
			"value":"Live",
			"sort":2,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"zh":"第五届国际商事法律合作论坛",
				"en":"The Fifth International Commercial Legal Cooperation Forum"
			},
			"remark":"/live",
			"children":[

			]
		},
		{
			"id":"1280765683141365762",
			"addTime":"2021-07-08 15:28:29",
			"updateTime":"2021-11-24 12:17:25",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"/guest",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"发言嘉宾",
			"value":"Speakers",
			"sort":3,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"zh":"第五届国际商事法律合作论坛",
				"en":"The Fifth International Commercial Legal Cooperation Forum"
			},
			"remark":"/guest",
			"children":[

			]
		},
		{
			"id":"1280765850531844098",
			"addTime":"2021-07-08 15:29:09",
			"updateTime":"2020-11-18 15:27:23",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"/news",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"论坛动态",
			"value":"Forum Status",
			// "value":"Essay Bulletin Board",
			"sort":4,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"zh":"第五届国际商事法律合作论坛",
				"en":"The Fifth International Commercial Legal Cooperation Forum"
			},
			"remark":"/news",
			"children":[

			]
		},
		// {
		// 	"id":"1328943857974398977",
		// 	"addTime":"2020-11-18 14:11:21",
		// 	"updateTime":"2020-11-20 15:10:01",
		// 	"type":{
		// 		"value":1,
		// 		"label":"导航栏配置"
		// 	},
		// 	"key":"/links",
		// 	"lang":{
		// 		"value":"zh_CN",
		// 		"label":"中文",
		// 		"alias":"zh_CN"
		// 	},
		// 	"label":"商务交流",
		// 	"value":"Business Cooperation",
		// 	"sort":5,
		// 	"pid":null,
		// 	"leaf":true,
		// 	"enabled":true,
		// 	"extra":{
		// 		"zh":"第五届国际商事法律合作论坛",
		// 		"en":"The Fifth International Commercial Legal Cooperation Forum"
		// 	},
		// 	"remark":"/links",
		// 	"children":[
		//
		// 	]
		// },
		// {
		// 	"id":"1328943857974398978",
		// 	"addTime":"2020-11-18 14:11:21",
		// 	"updateTime":"2020-11-20 15:10:01",
		// 	"type":{
		// 		"value":1,
		// 		"label":"导航栏配置"
		// 	},
		// 	"key":"/essayContest",
		// 	"lang":{
		// 		"value":"zh_CN",
		// 		"label":"中文",
		// 		"alias":"zh_CN"
		// 	},
		// 	"label":"征文大赛",
		// 	"value":"Essay Contest",
		// 	"sort":5,
		// 	"pid":null,
		// 	"leaf":true,
		// 	"enabled":true,
		// 	"extra":{
		// 		"zh":"第五届国际商事法律合作论坛",
		// 		"en":"The Fifth International Commercial Legal Cooperation Forum"
		// 	},
		// 	"remark":"",
		// 	"children":[

		// 	]
		// },
		{
			"id":"1280766374480105474",
			"addTime":"2020-07-08 15:31:14",
			"updateTime":"2020-11-20 15:09:26",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"往届论坛",
			"value":"Previous Forum",
			"sort":6,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"zh":"第五届国际商事法律合作论坛",
				"en":"The Fifth International Commercial Legal Cooperation Forum"
			},
			"remark":"",
			"children":[
				{
					"id":"1287585104255848452",
					"addTime":"2020-07-27 11:06:26",
					"updateTime":"2020-11-28 15:44:32",
					"type":{
						"value":1,
						"label":"导航栏配置"
					},
					"key":"https://ccpit.lawback.com/",
					"lang":{
						"value":"zh_CN",
						"label":"中文",
						"alias":"zh_CN"
					},
					"label":"2021届论坛",
					"value":"2021 ICLCF",
					"sort":1,
					"pid":"1280766374480105474",
					"leaf":true,
					"enabled":true,
					"extra":{
						"title":"2020国际商事法律合作论坛"
					},
					"remark":"https://ccpit.lawback.com/",
					"children":[

					]
				},
				{
					"id":"1287585104255848451",
					"addTime":"2020-07-27 11:06:26",
					"updateTime":"2020-11-28 15:44:32",
					"type":{
						"value":1,
						"label":"导航栏配置"
					},
					"key":"https://forum.lawback.com/",
					"lang":{
						"value":"zh_CN",
						"label":"中文",
						"alias":"zh_CN"
					},
					"label":"2020届论坛",
					"value":"2020 ICLCF",
					"sort":1,
					"pid":"1280766374480105474",
					"leaf":true,
					"enabled":true,
					"extra":{
						"title":"2020国际商事法律合作论坛"
					},
					"remark":"https://forum.lawback.com/",
					"children":[

					]
				},
				{
					"id":"1287585104255848450",
					"addTime":"2020-07-27 11:06:26",
					"updateTime":"2020-11-28 15:44:32",
					"type":{
						"value":1,
						"label":"导航栏配置"
					},
					"key":"https://enroll.lawback.com/forum/cooperationForum2019",
					"lang":{
						"value":"zh_CN",
						"label":"中文",
						"alias":"zh_CN"
					},
					"label":"2019届论坛",
					"value":"2019 ICLCF",
					"sort":1,
					"pid":"1280766374480105474",
					"leaf":true,
					"enabled":true,
					"extra":{
						"title":"2019国际商事法律合作论坛"
					},
					"remark":"https://enroll.lawback.com/forum/cooperationForum2019",
					"children":[

					]
				},
				{
					"id":"1287590375392874497",
					"addTime":"2020-07-27 11:27:22",
					"updateTime":"2020-11-09 14:18:15",
					"type":{
						"value":1,
						"label":"导航栏配置"
					},
					"key":"https://enroll.lawback.com/forum/cooperationForum",
					"lang":{
						"value":"zh_CN",
						"label":"中文",
						"alias":"zh_CN"
					},
					"label":"2018届论坛",
					"value":"2018 ICLCF",
					"sort":2,
					"pid":"1280766374480105474",
					"leaf":true,
					"enabled":true,
					"extra":{
						"title":"2018国际商事法律和论坛"
					},
					"remark":"https://enroll.lawback.com/forum/cooperationForum",
					"children":[

					]
				}
			]
		},
		{
			"id":"1332599708211740673",
			"addTime":"2020-11-28 16:18:24",
			"updateTime":"2020-11-28 16:18:24",
			"type":{
				"value":1,
				"label":"导航栏配置"
			},
			"key":"/about",
			"lang":{
				"value":"zh_CN",
				"label":"中文",
				"alias":"zh_CN"
			},
			"label":"关于论坛",
			"value":"About ICLCF",
			"sort":9,
			"pid":null,
			"leaf":true,
			"enabled":true,
			"extra":{
				"zh":"第五届国际商事法律合作论坛",
				"en":"The Fifth International Commercial Legal Cooperation Forum"
			},
			"remark":"/about",
			"children":[

			]
		},
		// {
		// 	"id":"1332600030648881154",
		// 	"addTime":"2020-11-28 16:19:40",
		// 	"updateTime":"2020-11-28 16:19:40",
		// 	"type":{
		// 		"value":1,
		// 		"label":"导航栏配置"
		// 	},
		// 	"key":"https://www.lawback.com/",
		// 	"lang":{
		// 		"value":"zh_CN",
		// 		"label":"中文",
		// 		"alias":"zh_CN"
		// 	},
		// 	"label":"服务平台",
		// 	"value":"Lawback",
		// 	"sort":9,
		// 	"pid":null,
		// 	"leaf":true,
		// 	"enabled":true,
		// 	"extra":{
		// 		"zh":"第五届国际商事法律合作论坛",
		// 		"en":"The Fifth International Commercial Legal Cooperation Forum"
		// 	},
		// 	"remark":null,
		// 	"children":[],
		// }
	],
	user: {},
	token: null,
	guest: null,
	iMUnRead: 0,
	viewsPlus: true,
	activeNav: null,
	locale: 'zh_CN',
	tokenHeader: 'Access-Token',
	totalVisit:0,
	visible: {
		im: false,
		book: false,
		login: false,
		logout: false
	},
	isOpenLiveNotice: false,
	bindSuccess:0,
	"currentLiveData":{},
	"liveQuantity": {},
	chatRoomMsg: [], //收到的聊天室消息
	chatRoomUserState: 'noShotup',//直播间用户禁言状态
	chartRoomId:null,
	videoLang:"zh_CN"
})

export const mutations = {
	SET_VISIT(state,data){
		state.totalVisit = data
	},
	SET_HEAD(state, head) {
		state.head = head
	},
	SET_NAVS(state, navs) {
		state.navs = navs
	},
	SET_LOCALE(state, locale) {
		state.locale = locale
	},
	SET_TOKEN(state, token) {
		state.token = token
	},
	SET_USER(state, user) {
		state.user = user
	},
	UPDATELAWYERDATA(state,value){
		if(process.browser){
			$nuxt.$cookies.set("lawyerInfo",value,{
				path: '/',
				maxAge:60 * 60 * 24 * 3650,
				secure:false
			});
		}
		state.lawyerInfo = value
	},
	SET_LOGIN(state, visible) {
		state.visible.login = visible
	},
	SET_LOGOUT(state, visible) {
		state.visible.logout = visible
	},
	SET_BOOK(state, guest) {
		state.guest = guest
		state.visible.book = !!guest
	},
	SET_IM(state, visible) {
		state.visible.im = visible
	},
	SET_ACTIVE_NAV(state, id) {
		state.activeNav = id
	},
	SET_VIEWS_PLUS(state, plus) {
		state.viewsPlus = plus
	},
	iMUnRead(state, count) {
		state.iMUnRead = count
	},
	SET_ISOPENLIVENOTICE(state, count) {
		state.isOpenLiveNotice = count;
	},
	/**
	 * @description: websoket绑定成功
	 * @date: 赵亚杰 2021/6/17 0017
	 */
	SET_BINDSUCCESS: (state, flag) => {
		state.bindSuccess += flag;
	},
	/**
	 * @method 当前直播数据
	 * @description:
	 * @date: 赵亚杰 2021/9/7 0007
	 */
	SET_CURRENTLIVEDATA: (state, data) => {
		state.currentLiveData = data;
	},
	MERGE_CURRENTLIVEDATA: (state, content) =>{
		console.log("当前语言",state.locale,content,state.currentLiveData)
	//合并直播状态等信息
	let {languages} = state.currentLiveData;
	if(languages==null || languages.length==0)return;
	let currentLive = languages.find((live)=>live.liveId == content.id);
	if(currentLive && currentLive.liveState){
		currentLive.live.liveState = currentLive.liveState.code = content.liveState;
		currentLive.live.liveStateName =currentLive.liveState.name =state.locale=="zh_CN"?content.liveStateName:content.liveStateNameEn;
		}
	console.log("llllllllll",state.currentLiveData)
	},
	/**
	 * @method 直播状态改变
	 * @description:
	 * @date: 赵亚杰 2021/9/7 0007
	 */
	SET_LIVEQUANTITY: (state, data) => {
		state.liveQuantity = data;
	},
	chatRoomUserState: (state, flag) => {
		state.chatRoomUserState = flag;
	},
	chatRoomMsg: (state, flag) => {
		if (flag === 'clearMsg') {
			state.chatRoomMsg = []
		} else {
			let ids =state.chatRoomMsg.filter(item=>_.isNumber(item.id)).map(item=>item.id);
			let lastId = Math.max(...ids);
			if(_.isNumber(lastId) && !_.isNumber(flag.id))flag.id = lastId+1;
			state.chatRoomMsg.push(flag);
			state.chatRoomMsg = [].concat(state.chatRoomMsg);
		}
	},
	lastChatRoomMsg:(state, chatRoomMsg)=>{
		let flagLast = chatRoomMsg;
		let chatRoomLastMsg = state.chatRoomMsg;
		if (flagLast === 'clearMsg') {
			chatRoomLastMsg = [];
		} else {
			// flagLast.forEach((item)=>{
			// 	chatRoomLastMsg.unshift(item);
			// })
			// 此处需倒序遍历
			for (var i=flagLast.length-1;i>=0;i--) {
			  chatRoomLastMsg.unshift(flagLast[i]);
			}
			state.chatRoomMsg = [].concat(chatRoomLastMsg);
		}
	},
	deleteChatRoomMsg:(state,msgId)=>{
			let chatRoomLastMsg = state.chatRoomMsg;
			let index = chatRoomLastMsg.findIndex(item=>item.msgId == msgId);
			if(index!=-1)chatRoomLastMsg.splice(index,1);
		state.chatRoomMsg = [].concat(chatRoomLastMsg);
	},
	SET_CHARTROOMID: (state, roomId) => {
		state.chatRoomId = roomId;
	},
	SET_VIDEOLANG: (state,videoLang) => {
		state.videoLang= videoLang?videoLang=="en"?"en_US":"zh_CN":state.videoLang=="zh_CN"?"en_US":"zh_CN";
	},
}

export const actions = {
	/**
	 * 服务端初始化
	 * @param commit
	 * @param $axios
	 * @returns {Promise<void>}
	 */
	async nuxtServerInit({ commit }, { $axios }) {
		//获取导航栏字典
		//const { data: navs } = await $axios.$get('navs')

		//commit('SET_NAVS', JSON.parse(navs))
	},
	/**
	 * 客户端初始化
	 * @param state
	 * @param dispatch
	 * @returns {Promise<void>}
	 */
	async nuxtClientInit({ state, dispatch }) {
		const token = Cookies.get(state.tokenHeader)
		if (token) {
			await dispatch('init', { token })
		}
		if (window._czc) {
			window._czc.push(['_setAccount', '1279448946'])
		}
	},
	/**
	 * 初始化token和用户信息
	 * @param commit
	 * @param dispatch
	 * @param token
	 * @returns {Promise<void>}
	 */
	async init({ commit, dispatch }, { token }) {
		await commit('SET_TOKEN', token)
		// await dispatch('-//////////////-*-***-**-**+-++*9++6998/63.3201414785')
	},
	/**
	 * 用户登录
	 * @param state
	 * @param commit
	 * @param dispatch
	 * @param params
	 * @returns {Promise<void>}
	 */
	async login({ state, commit, dispatch }, data) {
		// const { data } = await this.$axios.$post('auth/login', params)
		if (data.data) {
			console.log(data,'到底有用户信息吗')
			// 关闭登录对话框
			// commit('SET_LOGIN', false)
			// 登录用户信息
			commit('SET_USER', data.data.userInfo)
			// 保存token
			commit('SET_TOKEN', data.data.token);
			if(process.browser)webSocketLogin(data.data.userInfo,data.data.token);
			// 保存token到cookie中
			if (data.data.userInfo) Cookies.set('userInfo', data.data.userInfo,{ expires: 365 });
			if (data.data.token) Cookies.set('token', data.data.token,{ expires: 365 });
			Cookies.set(state.tokenHeader, data.data.token)
		}
	},
	/**
	 * 退出登录
	 * @param commit
	 * @returns {Promise<void>}
	 */
	async logout({ commit, state }) {
		await Promise.all([
			// 删除用户信息
			commit('SET_USER',{}),
			// 删除token
			commit('SET_TOKEN',''),
			// 关闭退出登录对话框
			commit('SET_LOGOUT', false),
			// 删除token
			Cookies.remove(state.tokenHeader),
			Cookies.remove('userInfo')
		])
	},
	/**
	 * 显示隐藏登录对话框
	 * @param commit
	 * @param visible
	 * @returns {Promise<void>}
	 */
	async loginVisible({ commit }, visible) {
		await commit('SET_LOGIN', visible)
	},
	/**
	 * 显示隐藏退出对话框
	 * @param commit
	 * @param visible
	 * @returns {Promise<void>}
	 */
	async logoutVisible({ commit }, visible) {
		await commit('SET_LOGOUT', visible)
	},
	/**
	 * 显示隐藏预约对话框
	 * @param commit
	 * @param guest
	 * @param visible
	 * @returns {Promise<void>}
	 */
	async bookVisible({ commit }, guest) {
		await commit('SET_BOOK', guest)
	},
	/**
	 * 显示隐藏IM
	 * @param commit
	 * @param visible
	 * @returns {Promise<void>}
	 */
	async imVisible({ commit }, visible) {
		await commit('SET_IM', visible)
	},
	/**
	 *
	 * @param commit
	 * @returns {Promise<void>}
	 */
	async setUser({ commit, state }) {
		if (state.token) {
			try {
				const { data } = await this.$axios.$get('user/info', { cache: false })
				if (data && data.uid) commit('SET_USER', data)
				else Cookies.remove(state.tokenHeader)
			} catch (e) {
				Cookies.remove(state.tokenHeader)
			}
		}
	},
	/**
	 *参会报名
	 * @param commit
	 * @param state
	 * @param query
	 * @returns {Promise<void>}
	 */
	async enroll({ commit, state }, query) {
		const me = this, path = state.locale === 'zh_CN' ? '/live' : '/en/live'

		if (state.user.uid) {
			await me.$router.push({ path, query })
		} else commit('SET_LOGIN', true)
	},
	/**
	 * @method
	 * @description: 登录后自动直播报名
	 * @date: 赵亚杰 2021/9/7 0007
	 */
	applicant({state}){
		let params = {
			year:new Date().getFullYear(),
			uid:state.user,
			name:state.showName,
			position:state.position,
			company:state.company,
			phone:state.phone,
			email:state.phone,
		}
		this.$axios.get("/forum/applicant",{
			parems
		})
	},
	async setActiveNav({ commit }, id) {
		commit('SET_ACTIVE_NAV', id)
	},
	toLogin({state,dispatch}){
		if(!state.user.uid){
			dispatch('loginVisible', true)
		}
	}
}
